__turbopack_context__.v({
  "lineHeightLoose": "Title-module__Xtwa_G__lineHeightLoose",
  "lineHeightNormal": "Title-module__Xtwa_G__lineHeightNormal",
  "lineHeightRelaxed": "Title-module__Xtwa_G__lineHeightRelaxed",
  "lineHeightSnug": "Title-module__Xtwa_G__lineHeightSnug",
  "lineHeightTight": "Title-module__Xtwa_G__lineHeightTight",
  "title": "Title-module__Xtwa_G__title",
  "titleL": "Title-module__Xtwa_G__titleL",
  "titleM": "Title-module__Xtwa_G__titleM",
  "titleS": "Title-module__Xtwa_G__titleS",
  "titleXL": "Title-module__Xtwa_G__titleXL",
  "titleXS": "Title-module__Xtwa_G__titleXS",
  "titleXXL": "Title-module__Xtwa_G__titleXXL",
  "titleXXS": "Title-module__Xtwa_G__titleXXS",
});
